/* eslint-disable */
import React, { useState } from 'react';
import { TextInput, TextArea, Button } from 'grommet';
import './styles/styles.css';
import SEO from './SEO';

const GOOGLE_ADS_SEND_TO = 'AW-16933443005/N1I1CJiwuPkbEL2rv4o_';

const reportMovingConversion = (leadId) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'conversion', {
    send_to: GOOGLE_ADS_SEND_TO,
    transaction_id: leadId,
  });
};

const pageStyle = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: '48px 24px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const cardStyle = {
  width: '100%',
  maxWidth: 640,
  background: 'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: '40px 40px 48px',
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const headingStyle = {
  fontSize: 32,
  fontWeight: 700,
  fontFamily: 'Raleway, sans-serif',
  marginBottom: 8,
  color: '#F5F5FA',
};

const subheadingStyle = {
  fontSize: 16,
  color: '#AAB5E0',
  marginBottom: 32,
  lineHeight: 1.6,
};

const labelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: '#AAB5E0',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  marginBottom: 6,
  display: 'block',
};

const fieldStyle = {
  marginBottom: 20,
};

const inputProps = {
  style: { fontFamily: 'Raleway, sans-serif', fontSize: '16px' },
};

const dividerStyle = {
  borderTop: '1px solid rgba(255,255,255,0.1)',
  margin: '28px 0',
};

const disclaimerStyle = {
  marginTop: 16,
  fontSize: 12,
  opacity: 0.65,
  textAlign: 'center',
  lineHeight: 1.5,
};

const successTitleStyle = {
  fontSize: 24,
  fontWeight: 700,
  marginBottom: 12,
  fontFamily: 'Raleway, sans-serif',
};

const successBodyStyle = {
  fontSize: 15,
  color: '#AAB5E0',
  lineHeight: 1.6,
};

const movingSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Moving Services SF Bay Area',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Bins Storage',
    url: 'https://bins-storage.com',
  },
  areaServed: ['San Francisco', 'Berkeley', 'Richmond', 'Bay Area'],
  description:
    'Bins connects you with vetted local movers in the SF Bay Area. Get a free quote for local moves, apartment moves, and moving storage.',
};

const Moving = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    moveDate: '',
    fromLocation: '',
    toLocation: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sendLead = () =>
    fetch('https://clrpa7xufk.execute-api.us-east-2.amazonaws.com/default/sendLead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...formData, type: 'moving' }),
    }).then((r) => r.json());

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    sendLead()
      .then((json) => {
        setIsSubmitted(true);
        const leadId =
          json?.reservationId ||
          `moving_${Date.now()}_${(formData.phone || '').replace(/\D/g, '')}`;
        reportMovingConversion(leadId);
      })
      .catch((err) => console.error('Moving lead error:', err))
      .finally(() => setIsSubmitting(false));
  };

  return (
    <>
      <SEO
        title="Local Movers San Francisco Bay Area | Get a Free Quote | Bins"
        description="Need a mover in San Francisco, Berkeley, or the East Bay? Bins connects you with vetted local movers. Fill out the form and we'll match you with the right team."
        path="/moving"
        schema={movingSchema}
      />
      <div style={pageStyle}>
        <div style={cardStyle}>
          {isSubmitted ? (
            <>
              <div style={successTitleStyle}>We'll be in touch shortly!</div>
              <div style={successBodyStyle}>
                Thanks for reaching out. Our team will review your move details and connect
                you with a vetted local mover — usually within a few hours during business
                hours.
              </div>
            </>
          ) : (
            <>
              <h1 style={headingStyle}>Get Help With Your Move</h1>
              <p style={subheadingStyle}>
                Moving in the SF Bay Area? Bins works with vetted local movers across San
                Francisco, Berkeley, and the East Bay. Share your move details and we'll
                match you with the right team — no commitment required.
              </p>

              <form onSubmit={handleSubmit}>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Your name</label>
                  <TextInput
                    name="name"
                    placeholder="Jane Smith"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    {...inputProps}
                  />
                </div>

                <div style={fieldStyle}>
                  <label style={labelStyle}>Email address</label>
                  <TextInput
                    type="email"
                    name="email"
                    placeholder="jane@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    {...inputProps}
                  />
                </div>

                <div style={fieldStyle}>
                  <label style={labelStyle}>Phone number</label>
                  <TextInput
                    name="phone"
                    placeholder="4155550100"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    pattern="[0-9]{10}"
                    title="Please enter a 10-digit phone number"
                    {...inputProps}
                  />
                </div>

                <div style={dividerStyle} />

                <div style={fieldStyle}>
                  <label style={labelStyle}>Planned move date</label>
                  <TextInput
                    name="moveDate"
                    placeholder="e.g. May 15, 2026"
                    value={formData.moveDate}
                    onChange={handleChange}
                    required
                    {...inputProps}
                  />
                </div>

                <div style={fieldStyle}>
                  <label style={labelStyle}>Moving from</label>
                  <TextInput
                    name="fromLocation"
                    placeholder="e.g. Mission District, SF"
                    value={formData.fromLocation}
                    onChange={handleChange}
                    required
                    {...inputProps}
                  />
                </div>

                <div style={fieldStyle}>
                  <label style={labelStyle}>Moving to</label>
                  <TextInput
                    name="toLocation"
                    placeholder="e.g. Temescal, Oakland"
                    value={formData.toLocation}
                    onChange={handleChange}
                    required
                    {...inputProps}
                  />
                </div>

                <div style={fieldStyle}>
                  <label style={labelStyle}>Anything else we should know? (optional)</label>
                  <TextArea
                    name="message"
                    placeholder="e.g. 1-bedroom apartment, need help with a piano, also need storage after the move..."
                    value={formData.message}
                    onChange={handleChange}
                    {...inputProps}
                  />
                </div>

                <Button
                  className="button1"
                  type="submit"
                  primary
                  fill="horizontal"
                  disabled={isSubmitting}
                  label={isSubmitting ? 'Submitting…' : 'Get a free quote'}
                  style={{ marginTop: 8 }}
                />

                <div style={disclaimerStyle}>
                  No commitment. We'll reach out to confirm details and match you with the
                  right mover for your area.
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Moving;
